var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpusLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 47,
    viewBox: "0 0 294 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1991_6522)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1152 24.3799C60.1152 24.3799 63.1023 30.9256 58.186 37.3425C58.186 37.3425 53.8091 39.0379 49.0381 36.0119C49.0381 36.0119 55.3856 29.3589 50.7391 22.8562C50.7391 22.8562 56.3813 21.0964 60.0945 24.3585L60.1152 24.3799Z",
    fill: "url(#paint0_linear_1991_6522)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9316 13.3917C12.011 10.3657 6.86661 8.75612 1.59772 13.9068C1.51474 14.1858 -2.67548 26.8908 2.94606 36.2479C2.94606 36.2479 8.7128 40.7762 16.5746 35.5182C15.2678 33.9301 8.13197 24.3155 15.9523 13.3917H15.9316Z",
    fill: "url(#paint1_linear_1991_6522)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.95718 36.4196C9.50082 36.2264 8.15248 35.0031 7.55092 34.0588C6.94935 33.136 6.4515 32.1273 6.05737 31.0757C5.3106 28.9511 4.93722 26.7406 4.9787 24.4872C4.9787 23.3712 5.08242 22.2552 5.24837 21.1607C5.39358 20.0662 5.66324 18.9502 5.99514 17.8986C6.34778 16.8255 6.84563 15.8168 7.50943 14.9155C7.84133 14.4648 8.21471 14.057 8.65033 13.7136C9.08595 13.3703 9.5838 13.1127 10.1024 12.941C9.54231 13.3059 9.23115 13.6063 8.81628 13.9497C8.42215 14.2931 8.06951 14.7009 7.7791 15.1515C7.17753 16.0529 6.72117 17.0187 6.41002 18.0703C5.78771 20.1735 5.47655 22.341 5.47655 24.5301C5.43506 26.7191 5.74622 28.8867 6.4515 30.947C6.80415 31.9771 7.26051 32.9643 7.82058 33.8872C8.09025 34.3378 8.42215 34.7885 8.75405 35.1963C9.10669 35.6041 9.50082 36.1191 9.9157 36.441C9.95718 36.4625 9.95718 36.3981 9.9157 36.441C9.93644 36.441 9.9157 36.4625 9.9157 36.441L9.95718 36.4196Z",
    fill: "url(#paint2_linear_1991_6522)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M52.1291 25.6676C52.1291 25.6676 57.8336 23.7146 60.9866 28.0927C60.8622 26.7836 60.6133 25.6461 60.1362 24.4014C60.1362 24.4014 56.8794 20.9461 50.7808 22.8991C51.3201 23.6717 51.8802 24.6589 52.1498 25.689L52.1291 25.6676Z",
    fill: "url(#paint3_linear_1991_6522)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M50.4282 34.2091C50.4282 34.2091 52.2536 38.2438 58.6219 36.763L58.1863 37.3639C58.1863 37.3639 53.5605 39.0808 49.0591 36.0118C49.0798 36.0118 49.4947 35.5397 49.5154 35.4968C49.6814 35.2822 49.8059 35.1319 49.9511 34.9173C49.9925 34.8744 50.117 34.7027 50.1378 34.6383L50.4282 34.2091Z",
    fill: "url(#paint4_linear_1991_6522)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M13.4628 17.7913C14.0229 16.3534 14.8527 14.8726 15.9106 13.3917C12.0523 10.3872 6.72115 8.67028 1.76341 13.7566C1.74267 13.778 1.70118 13.7995 1.65969 13.8424C1.6182 13.8853 1.59746 13.9068 1.55597 13.9283C1.09961 15.3662 0.767715 16.8255 0.518791 18.3064C0.518791 18.3493 0.518791 18.3922 0.498047 18.4566C0.622509 18.242 5.68396 9.97941 13.4421 17.7913H13.4628Z",
    fill: "url(#paint5_linear_1991_6522)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5769 13.9068L2.13697 12.7479C2.61408 11.7607 3.1949 10.8378 3.81721 9.93647C5.41447 7.57574 7.48884 5.12916 10.0611 3.86295C11.8035 3.00451 13.8157 2.74697 15.7241 2.98305C21.3664 3.6698 25.0795 8.17665 28.4814 12.426C30.2239 14.5935 31.9041 16.804 33.6051 19.0146C38.4799 25.3671 47.5656 40.6045 58.1864 37.3639C58.1864 37.3639 48.6235 50.6913 34.2482 35.4538C34.2482 35.4538 24.5816 23.8219 22.5695 20.9246C20.5574 18.0273 11.3057 4.39948 1.55615 13.9068H1.5769Z",
    fill: "url(#paint6_linear_1991_6522)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.1004 40.2397C48.7478 40.2397 48.4159 40.2182 48.0633 40.1753C47.1505 40.0251 46.2586 39.7461 45.4288 39.3598C44.5991 38.995 43.7901 38.5228 43.0225 37.9648C42.255 37.4283 41.5497 36.8274 40.8652 36.1835C37.9818 33.7584 35.5756 30.8826 32.8374 27.3415C31.6135 25.7534 30.4311 24.1438 29.2695 22.5342L25.7846 17.684C24.6229 16.0744 23.4198 14.4648 22.1544 12.9411C21.5321 12.1685 20.889 11.4173 20.1838 10.7306C19.52 10.0009 18.7732 9.37852 17.9642 8.84199C17.1552 8.32692 16.2632 7.8977 15.3505 7.59724C14.8941 7.44701 14.4378 7.33971 13.9607 7.25386C13.4836 7.16802 13.0065 7.12509 12.5293 7.10363C10.4757 7.10363 8.67103 7.70455 7.15674 8.82053C8.62954 7.44701 10.6002 6.76025 12.5916 6.76025C14.6037 6.78172 16.5536 7.38263 18.2546 8.47715C19.1051 9.01368 19.8726 9.65751 20.5779 10.3872C21.2832 11.0954 21.947 11.8466 22.59 12.6192C23.8554 14.1644 25.0585 15.7525 26.2409 17.3621C27.1121 18.5639 27.9834 19.7657 28.8546 20.9676C30.3274 23.0064 31.7795 25.0237 33.2938 27.0196C34.4969 28.6077 35.7415 30.153 37.0484 31.6338C38.3137 33.1361 39.7243 34.5525 41.1971 35.8402C41.8402 36.484 42.5454 37.0849 43.2715 37.6214C43.9975 38.158 44.7857 38.6301 45.5948 39.0379C46.4038 39.4456 47.2542 39.7246 48.1462 39.8749C48.5404 39.9393 48.9137 39.9822 49.3079 39.9822C49.9094 39.9607 50.3451 39.8963 50.8014 39.7676C50.6355 39.9178 49.9509 40.1753 49.4946 40.1968H49.1419L49.1004 40.2397Z",
    fill: "url(#paint7_linear_1991_6522)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M34.0405 19.6155L32.7544 17.92L25.4941 24.7232L26.8217 26.3758C29.0621 23.9506 31.4476 21.6758 34.0198 19.6155H34.0405Z",
    fill: "url(#paint8_linear_1991_6522)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M35.4511 36.6342L42.255 30.2173L41.6119 29.4876L40.8859 28.6506L33.9575 35.1105L34.6421 35.8401L35.4511 36.6342Z",
    fill: "url(#paint9_linear_1991_6522)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6779 35.3895C16.6779 35.3895 20.0591 33.6941 26.7178 26.4831C29.1655 23.8434 31.7585 21.311 34.6004 19.1219C37.2141 17.0831 40.2012 15.1301 43.4164 14.3361C49.3906 12.8338 55.9456 16.0315 58.912 21.547C59.4098 22.4699 59.8039 23.4356 60.1358 24.4443C60.1358 24.4443 53.5808 19.4438 44.2669 26.1183C41.6117 28.0283 39.164 30.3247 36.7577 32.5566C34.7663 34.4023 32.7957 36.2694 30.9288 38.2438C29.0618 40.2183 27.1742 42.0639 24.8716 43.4589C22.5691 44.8539 19.9968 45.7767 17.3417 45.8411C14.6657 45.9055 11.9898 45.1114 9.68724 43.7165C8.25593 42.858 6.94908 41.7635 5.80817 40.5187C5.22735 39.8964 4.66727 39.2096 4.16942 38.5014C3.94124 38.158 3.73381 37.8146 3.54711 37.4498C2.86257 36.1192 3.54711 37.4498 2.9248 36.248C2.9248 36.248 8.71229 40.7119 16.6779 35.3895Z",
    fill: "url(#paint10_linear_1991_6522)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1721 6.00913C42.1721 9.31415 39.5792 12.0183 36.3639 12.0183C33.1486 12.0183 30.5557 9.33562 30.5557 6.00913C30.5557 2.68265 33.1486 0 36.3639 0C39.5792 0 42.1721 2.68265 42.1721 6.00913Z",
    fill: "url(#paint11_linear_1991_6522)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2223 1.95298L39.2681 3.28357C39.1021 3.15481 38.9362 3.02604 38.7495 2.91873L39.6207 1.45937C39.8282 1.6096 40.0356 1.78129 40.2223 1.95298ZM33.1694 1.63106L33.5221 2.59682C35.0156 1.91006 36.7166 1.93152 38.2101 2.63974L38.9362 1.05161C37.0692 0.0858568 34.8289 0.32193 33.1694 1.63106Z",
    fill: "url(#paint12_radial_1991_6522)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M37.3389 7.03924C34.9949 7.03924 32.8376 5.64426 31.8004 3.47668C30.4313 6.09495 31.3648 9.33559 33.8955 10.752C36.4262 12.1685 39.5585 11.2027 40.9276 8.58445C41.3425 7.81184 41.5499 6.93194 41.5499 6.03057C41.5499 5.79449 41.5499 5.57988 41.5084 5.34381C40.3675 6.43833 38.874 7.03924 37.3389 7.03924Z",
    fill: "url(#paint13_linear_1991_6522)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M2.92498 36.2479C2.92498 36.2479 2.94572 36.2479 2.96647 36.2909C3.33985 36.5269 3.69249 36.7415 4.06588 36.9347C4.19034 36.9991 4.3148 37.042 4.43927 37.1064C4.5015 37.1278 4.54298 37.1493 4.60522 37.1708C6.86628 38.1151 11.181 38.9735 16.5121 35.4968C15.1637 33.8872 14.2095 31.8484 14.2095 31.8484C9.81188 39.3598 2.13672 34.81 2.13672 34.81L2.5101 35.5612L2.90423 36.2694L2.92498 36.2479Z",
    fill: "url(#paint14_linear_1991_6522)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.1224 41.0338C14.7283 41.0338 14.3549 40.9694 13.9607 40.8835C13.5874 40.7762 13.214 40.6475 12.8613 40.4758C12.8613 40.4758 14.3549 40.7762 15.1224 40.7762C15.8692 40.7762 16.6159 40.6689 17.342 40.4543C18.068 40.2397 18.7733 39.9822 19.4578 39.6388C20.1424 39.3169 20.8062 38.9306 21.4285 38.5014C22.839 37.6429 24.1874 36.6772 25.4527 35.647C26.7388 34.6169 27.9835 33.5224 29.2073 32.3849C30.7009 31.0114 32.1737 29.5735 33.6257 28.1571C34.5385 27.2557 35.4719 26.3543 36.4054 25.4744C37.6085 24.3155 38.8324 23.1781 40.0978 22.0835C40.7408 21.547 41.3839 21.0105 42.0892 20.5383C42.753 20.0447 43.4997 19.637 44.288 19.3151C45.3874 18.8644 46.5491 18.6283 47.7314 18.6283C48.2293 18.6283 48.7271 18.6712 49.225 18.7571C50.8637 19.0575 52.3988 19.916 53.5397 21.1822C52.2743 20.1306 50.76 19.3365 49.1628 19.079C48.7479 19.0146 48.3123 18.9717 47.8974 18.9717C47.524 18.9717 47.1506 18.9931 46.7565 19.0575C45.9682 19.1648 45.18 19.4009 44.4332 19.7014C43.6864 20.0233 42.9811 20.431 42.3381 20.9246C41.6743 21.4182 41.0312 21.9548 40.4089 22.4698C39.1643 23.5429 37.9404 24.7018 36.758 25.8393L33.1901 29.316C31.987 30.4749 30.7839 31.6338 29.56 32.7498C26.8011 35.2607 24.3948 37.2566 21.6566 38.8447C21.0136 39.274 20.329 39.6603 19.6238 39.9822C18.9185 40.3041 18.1925 40.5831 17.4457 40.7548C16.7611 40.9265 16.0766 41.0338 15.3713 41.0338C15.3713 41.0338 15.1639 41.0338 15.1431 41.0338H15.1224Z",
    fill: "url(#paint15_linear_1991_6522)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8134 37.1064C53.332 36.806 53.8505 36.2695 54.2239 35.7973C54.6181 35.3252 54.9707 34.8101 55.2611 34.2736C55.8419 33.179 56.2153 31.9987 56.402 30.7539C56.6095 29.5092 56.6302 28.2644 56.5057 27.0197C56.4435 26.4188 56.2776 25.8179 56.0286 25.2599C55.9042 24.9809 55.759 24.7233 55.5723 24.4873C55.3856 24.2512 55.1574 24.058 54.9085 23.8864C55.2611 23.8864 55.5723 24.0795 55.7797 24.2941C56.0079 24.5516 56.1946 24.8092 56.3398 25.1096C56.6302 25.6891 56.8376 26.3115 56.9414 26.9768C57.128 28.2644 57.128 29.5736 56.9206 30.8612C56.7339 32.1489 56.2983 33.3937 55.6552 34.5311C55.3233 35.0891 54.95 35.6042 54.4936 36.0763C54.058 36.5485 53.4149 36.8704 52.8134 37.1494V37.1064Z",
    fill: "url(#paint16_linear_1991_6522)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0823 8.6488C95.7324 8.6488 102.308 15.4949 102.308 23.7789C102.308 32.063 95.7324 38.9091 87.0823 38.9091C78.4322 38.9091 71.8564 32.063 71.8564 23.7789C71.8564 15.4949 78.4322 8.6488 87.0823 8.6488ZM87.0823 33.1146C92.0815 33.1146 96.1058 28.9725 96.1058 23.7789C96.1058 18.5853 92.1023 14.4433 87.0823 14.4433C82.0623 14.4433 78.0588 18.5853 78.0588 23.7789C78.0588 28.9725 82.0623 33.1146 87.0823 33.1146Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.142 17.9844H112.556V20.8817H112.763C113.157 20.2593 113.697 19.7228 114.298 19.2292C115.377 18.3922 116.87 17.5767 118.986 17.5767C123.633 17.5767 127.802 21.9762 127.802 28.157C127.802 34.3378 123.633 38.7374 118.986 38.7374C116.87 38.7374 115.377 37.9004 114.298 37.0849C113.697 36.5913 113.178 36.0547 112.763 35.4324H112.556V47.0429H107.142V18.0273V17.9844ZM122.367 28.1356C122.367 25.0237 120.169 22.7488 117.368 22.7488C114.568 22.7488 112.369 25.0237 112.369 28.1356C112.369 31.2474 114.568 33.5223 117.368 33.5223C120.169 33.5223 122.367 31.2474 122.367 28.1356Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.2 17.9844H137.614V29.3803C137.614 31.8698 138.983 33.3291 141.223 33.3291C143.629 33.3291 145.434 31.462 145.434 28.7794V17.9844H150.848V38.3081H145.434V35.4109H145.227C144.791 36.0332 144.314 36.5698 143.754 37.0634C142.8 37.9004 141.306 38.7159 139.419 38.7159C135.415 38.7159 132.2 35.4109 132.2 30.2173V17.9844Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.652 31.462C158.046 31.9127 158.524 32.299 159.042 32.621C159.976 33.2433 161.241 33.7369 162.859 33.7369C164.664 33.7369 165.265 33.1146 165.265 32.299C165.265 30.0027 155.246 30.4319 155.246 23.8004C155.246 20.4739 158.046 17.5767 163.066 17.5767C165.597 17.5767 167.485 18.3707 168.75 19.1433C169.518 19.594 170.14 20.1305 170.679 20.6671L167.464 24.1867C167.132 23.9077 166.738 23.6073 166.302 23.3497C165.535 22.899 164.456 22.5342 163.066 22.5342C161.677 22.5342 161.075 23.1566 161.075 23.7789C161.075 26.0753 171.094 25.6461 171.094 32.2776C171.094 35.7543 168.294 38.6945 162.88 38.6945C160.162 38.6945 158.067 37.7931 156.636 36.8273C155.785 36.2908 155.08 35.6684 154.479 34.9602L157.694 31.4406L157.652 31.462Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.569 9.27112H189.369L200.986 38.2866H197.771L194.555 30.1958H181.342L178.126 38.2866H174.911L186.528 9.27112H186.569ZM193.373 27.2985L187.959 13.6277L182.545 27.2985H193.373Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.404 18.3921H208.205V21.2894C208.64 20.667 209.159 20.1305 209.843 19.6369C210.922 18.7999 212.561 17.9844 214.801 17.9844C220.008 17.9844 224.219 22.341 224.219 28.3501C224.219 34.3593 220.008 38.7159 214.801 38.7159C212.561 38.7159 210.922 37.8789 209.843 37.0634C209.159 36.5698 208.64 36.0332 208.205 35.4109V47.0214H205.404V18.4136V18.3921ZM221.439 28.3501C221.439 23.8218 218.473 20.667 214.822 20.667C211.461 20.667 208.205 23.9935 208.205 28.3501C208.205 32.7068 211.441 36.0118 214.822 36.0118C218.473 36.0118 221.439 32.857 221.439 28.3501Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M245.896 34.5739C245.336 35.3679 244.651 36.0118 243.842 36.6341C242.453 37.6857 240.482 38.7159 237.868 38.7159C232.62 38.7159 228.243 34.1661 228.243 28.3501C228.243 22.5341 232.662 17.9844 237.661 17.9844C242.909 17.9844 246.871 22.1264 246.871 27.9424C246.871 28.3931 246.788 28.7364 246.747 29.0154L246.664 29.4232L231.044 29.3803C231.23 32.8999 234.197 36.0118 237.847 36.0118C239.901 36.0118 241.374 35.1748 242.453 34.3593C243.054 33.8657 243.614 33.3291 244.05 32.7067L245.855 34.5739H245.896ZM244.091 26.8908C243.656 23.3711 241.084 20.667 237.682 20.667C234.28 20.667 231.521 23.5643 231.064 26.8908H244.091Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.716 9.89355C254.712 9.89355 255.521 10.7091 255.521 11.7607C255.521 12.8123 254.712 13.6278 253.716 13.6278C252.721 13.6278 251.912 12.8123 251.912 11.7607C251.912 10.7091 252.721 9.89355 253.716 9.89355ZM252.306 18.3922H255.106V38.2867H252.306V18.3922Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M261.931 18.3922H264.731V21.0963C265.167 20.5597 265.685 20.0232 266.287 19.5725C267.365 18.7785 268.901 18.0059 271.141 18.0059H271.95V20.9031H270.747C267.531 20.9031 264.731 23.3926 264.731 27.32V38.3081H261.931V18.4136V18.3922Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M274.356 28.3501C274.356 22.5341 278.774 17.9844 284.188 17.9844C289.603 17.9844 294 22.5556 294 28.3501C294 34.1447 289.603 38.7159 284.188 38.7159C278.774 38.7159 274.356 34.1661 274.356 28.3501ZM291.179 28.3501C291.179 23.9935 287.985 20.667 284.168 20.667C280.351 20.667 277.156 23.9935 277.156 28.3501C277.156 32.7068 280.372 36.0118 284.168 36.0118C287.964 36.0118 291.179 32.7068 291.179 28.3501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1991_6522",
    x1: 50.7183,
    y1: 37.042,
    x2: 58.8135,
    y2: 23.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED64B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E55FB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D053B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B244AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8F36A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#6D2B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#522493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1991_6522",
    x1: 10.9739,
    y1: 37.8575,
    x2: 6.07719,
    y2: 10.9161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#462290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#522493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#6D2B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8F36A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#B244AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#D053B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E55FB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED64B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1991_6522",
    x1: 7.34348,
    y1: 36.5054,
    x2: 8.03175,
    y2: 12.7063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1991_6522",
    x1: 50.76,
    y1: 25.1954,
    x2: 60.9659,
    y2: 25.1954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#462290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED64B8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1991_6522",
    x1: 49.0591,
    y1: 36.0333,
    x2: 58.6219,
    y2: 36.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#462290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED64B8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1991_6522",
    x1: 3.40216,
    y1: 20.9461,
    x2: 12.5288,
    y2: 10.4353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED64B8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1991_6522",
    x1: 26.0959,
    y1: 0.858388,
    x2: 33.3662,
    y2: 45.2926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00A8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0096E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#007ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0065C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#004DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#003C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1991_6522",
    x1: 7.03228,
    y1: 23.5214,
    x2: 50.8014,
    y2: 23.5214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1991_6522",
    x1: 25.4941,
    y1: 22.1479,
    x2: 34.0405,
    y2: 22.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1991_6522",
    x1: 33.9575,
    y1: 32.6424,
    x2: 42.255,
    y2: 32.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1991_6522",
    x1: 15.9726,
    y1: 49.5324,
    x2: 48.8974,
    y2: 11.6189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#003C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#004DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0065C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#007ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0096E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00A8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1991_6522",
    x1: 30.5764,
    y1: 6.00913,
    x2: 42.1721,
    y2: 6.00913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00A8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0096E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#007ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0065C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#004DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#003C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003594"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1991_6522",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0356 3.21919) rotate(180) scale(5.01997 5.19361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64ABDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#7CB9E1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#93C6E6",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8D2EA",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BBDBEE",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C9E1F0",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D3E6F2",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D9E9F4",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEAF4",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1991_6522",
    x1: 31.1781,
    y1: 7.44701,
    x2: 41.5707,
    y2: 7.44701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1991_6522",
    x1: 2.15746,
    y1: 34.9173,
    x2: 16.5328,
    y2: 34.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED64B8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1991_6522",
    x1: 12.7991,
    y1: 29.8525,
    x2: 53.6434,
    y2: 29.8525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1991_6522",
    x1: 54.3691,
    y1: 37.4927,
    x2: 56.3647,
    y2: 23.9052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1991_6522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpusLogo);
export default __webpack_public_path__ + "static/media/opus-logo.8a5dc4621c48b25375d1e16008aab7b3.svg";
export { ForwardRef as ReactComponent };